import React from 'react';
import { Button, ButtonProps } from '../../components/button';
import { IconName } from '../../tokens/icons';
import s from './PatternCTASet.module.css';

export type CTAInput = Partial<Pick<ButtonProps, 'variant'>> &
    Pick<
        ButtonProps,
        'label' | 'hrefLink' | 'icon' | 'onClick' | 'disabled' | 'radiusSize'
    > & {
        active?: boolean;
        icon?: IconName;
    };

export type CTASet = CTAInput[];

export type CTASetProps = {
    set: CTASet;
    lang: string;
};

export const PatternCTASet = ({ set, lang }: CTASetProps) => {
    return (
        <div className={s.root}>
            {set?.map((button: CTAInput) => {
                const {
                    label,
                    hrefLink,
                    icon,
                    onClick,
                    disabled,
                    radiusSize,
                    variant,
                } = button;

                return (
                    label && (
                        <Button
                            variant={variant}
                            radiusSize={radiusSize}
                            hrefLink={hrefLink}
                            label={label}
                            icon={icon}
                            key={label || hrefLink}
                            onClick={onClick}
                            disabled={disabled}
                            lang={lang}
                        />
                    )
                );
            })}
        </div>
    );
};

export default PatternCTASet;
